import styles from './RecipeListingPageLayout.module.scss';

type RecipeListingPageLayoutProps = {
  gridType: 'recipe-cards' | 'featured';
  disableFilters: boolean;
  disableSortBy: boolean;
  preloadImages: boolean;
  filterComponent: React.ReactNode;
  sortByComponent: React.ReactNode;
  recipeCardGrid: React.ReactNode;
};

const RecipeListingPageLayout = ({
  filterComponent,
  sortByComponent,
  recipeCardGrid,
  disableFilters,
  disableSortBy,
}: RecipeListingPageLayoutProps) => (
  <div className={styles.recipeLayout}>
    {disableFilters ? null : <aside className={styles.filters}>{filterComponent}</aside>}
    <div className={styles.content}>
      {disableSortBy ? null : <div className={styles.sort}>{sortByComponent}</div>}
      <div className={styles.listing}>{recipeCardGrid}</div>
    </div>
  </div>
);

export default RecipeListingPageLayout;
